import { render, staticRenderFns } from "./orderException.vue?vue&type=template&id=752947e5&scoped=true"
import script from "./orderException.vue?vue&type=script&lang=js"
export * from "./orderException.vue?vue&type=script&lang=js"
import style0 from "./orderException.vue?vue&type=style&index=0&id=752947e5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752947e5",
  null
  
)

export default component.exports